import React from "react";
import Paper from "material-ui/Paper";
import { withStyles } from "material-ui/styles";
import isMobile from "ismobilejs";
import QuestionData from "assets/data/QuestionData";
import { isAnswer } from "utils/formatter";

const browserStyles = theme => ({
  container: {
    margin: 20,
    padding: 20,
    backgroundColor: theme.palette.answer.backgroundColor,
    height: 570,
    position: "relative"
  },
  main: {
    textAlign: "center"
  },
  text: {
    fontSize: "1.6rem",
    marginTop: 200
  },
  returnBtnDiv: {},
  returnBtn: {},
  footer: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    margin: "0 -40px 10px",
    textAlign: "right"
  }
});

const mobileStyles = theme => ({
  container: {
    margin: 10,
    padding: 10,
    backgroundColor: theme.palette.answer.backgroundColor,
    minHeight: 340,
    position: "relative"
  },
  main: {
    textAlign: "center"
  },
  text: {
    fontSize: "1.1rem",
    marginTop: 140
  },
  returnBtnDiv: {},
  returnBtn: {},
  footer: {
    fontSize: ".8rem",
    position: "absolute",
    bottom: 0,
    width: "92%",
    marginBottom: 10,
    textAlign: "right"
  }
});

class AnswerComplete extends React.Component {
  componentWillMount() {
    const { answerToken } = this.props.answerHeader;
    window.addEventListener('popstate', this.popStateListener, false);

    if (!answerToken) {
      // answerTokenなしは認証エラー
      this.props.showErrorDialog();
    }
  }

  popStateListener = () => {
    window.removeEventListener('popstate', this.popStateListener);
    if(isAnswer()){
      const { confirmBrowserBackDialog } = this.props;
      confirmBrowserBackDialog();
    }
  };

  componentWillUnmount() {
    if (isAnswer()) {
      window.removeEventListener("popstate", this.showReloadAlert);
    }
  }

  showReloadAlert(e) {
    e.returnValue = "回答は削除されます。";
  }

  render() {
    // 認証トークンがなければ画面の描写をしない
    if (!this.props.answerHeader.answerToken) {
      return null;
    }

    const { classes, locale } = this.props;

    return (
      <Paper className={classes.container}>
        <div className={classes.main}>
          <div className={classes.text}>
            {QuestionData.SENTENSE[locale.key].completeTitle}
          </div>
        </div>

        <div className={classes.footer}>
          （公財）日本生産性本部 コンサルティング部
        </div>
      </Paper>
    );
  }
}

export default withStyles(isMobile.any ? mobileStyles : browserStyles)(
  AnswerComplete
);



// WEBPACK FOOTER //
// ./src/components/answer/AnswerComplete.jsx